import { combineReducers } from "redux";

import authReducer from "src/state/ducks/auth";

export const rootReducer = combineReducers({
    auth: authReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
